import { appendPath, getValue } from '@truqc/content-path';
import { createSelector } from 'reselect';
import { getContent, getParentContentPath, getStaticContent } from './simpleSelectors';
const getFormatUnits = (state, props) => props.format.units;
const getFormatUnitsContentPath = (state, props) => props.format.unitsIdentifierContentPath;
const getFormatUnitsIdentifier = (state, props) => props.format.unitsIdentifier;
export default createSelector([getContent, getStaticContent, getFormatUnits, getFormatUnitsContentPath, getFormatUnitsIdentifier, getParentContentPath], (content, staticContent, units, unitsIdentifierContentPath, unitsIdentifier, parentContentPath) => {
  if (!units && !unitsIdentifierContentPath && !unitsIdentifier) return null;
  if (units) return units;
  if (unitsIdentifier) return unitsIdentifier;

  // Use parent path when looking up identifier path to properly parse siblings
  const unitsPath = appendPath(parentContentPath, unitsIdentifierContentPath);
  let result = getValue(unitsPath, content);
  if (result === undefined) {
    result = getValue(unitsPath, staticContent);
  }
  return result;
});